import React, { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

interface VideoItem {
  id: string;
  url: string;
  title: string;
  description: string;
}

const ITEMS_PER_PAGE = 8;

const VideoGalleryPage: React.FC = () => {
  const [videoList, setVideoList] = useState<VideoItem[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchVideos = async () => {
      const { data, error } = await supabase.from('videos').select('*');
      if (error) {
        console.error("Video listesi alınamadı:", error);
      } else {
        setVideoList(data as VideoItem[]);
      }
      setLoading(false);
    };
    fetchVideos();
  }, []);

  const totalPages = Math.ceil(videoList.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentVideos = videoList.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen mb-48">
      {/* Başlık */}
      <section className="text-center py-10 px-6 bg-[#002744] text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Video Galeri</h1>
        <p className="text-lg max-w-2xl mx-auto opacity-80">
          Teknelerimizin video tanıtımlarını keşfedin
        </p>
      </section>

      {/* Galeri */}
      <div className="max-w-7xl mx-auto px-4 text-center mb-12 mt-20 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {currentVideos.map((video, index) => (
          <div key={index} className="rounded overflow-hidden shadow-lg">
            <video
              className="w-full h-48 object-cover"
              src={video.url}
              controls
              preload="metadata"
            />
            <div className="p-2 text-left mt-2 mb-3">
              <h2 className="font-semibold text-lg text-black">{video.title}</h2>
              <p className="text-sm text-black mt-3">{video.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Sayfalama */}
      <div className="flex justify-center items-center gap-2 text-black mt-8 min-h-[80px]">
        <button
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          ◀ Önceki
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`px-3 py-1 rounded ${
              currentPage === i + 1
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Sonraki ▶
        </button>
      </div>
    </div>
  );
};

export default VideoGalleryPage;
